export default {
  socials: (state) => state.socials,
};
